/* Princeium — cart drawer, quick add-to-cart, bundle progress, mobile menu, gallery, sort.
   Without JavaScript everything still works: forms post to /cart/add and the cart links go to /cart. */
(function () {
  if (window.__princeiumLoaded) return;
  window.__princeiumLoaded = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var $ = function (sel, el) { return (el || document).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); };

  function money(cents, currency) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  var GENERIC = '|4th of july|fourth of july|july 4th|halloween|christmas|xmas|thanksgiving|new year|new years|new year\u2019s|fall|autumn|easter|valentine|valentines|valentines day|valentine\u2019s day|st patrick day|st patricks day|st. patrick\u2019s day|mothers day|fathers day|juneteenth|america|usa|patriotic|png|svg|png bundle|bundle|sublimation|digital download|';
  function cleanPart(c) {
    c = c.split(' | ')[0].split(' Sublimation')[0].split(' sublimation')[0].split(' Png Design')[0].split(' PNG Design')[0].split(' Digital Download')[0].trim();
    var tail = c.slice(-4).toLowerCase();
    if (tail === ' png' || tail === ' svg') c = c.slice(0, -4).trim();
    return c;
  }
  function cleanTitle(t) {
    t = String(t || '');
    var parts = t.split(', '), first = '';
    for (var i = 0; i < parts.length; i++) {
      var c = cleanPart(parts[i]);
      if (i === 0) first = c;
      if (c && GENERIC.indexOf('|' + c.toLowerCase() + '|') === -1) return c;
    }
    return first || t;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ---------- Drawers (cart + mobile menu) ---------- */
  var lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    document.documentElement.classList.add('pr-lock');
    var focusable = el.querySelector('button, a, input');
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
    updateMobileBar();
  }
  function closeDrawer(el) {
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    document.documentElement.classList.remove('pr-lock');
    setTimeout(function () { el.hidden = true; updateMobileBar(); }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- Cart state ---------- */
  var state = { cart: null };

  function fetchCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { state.cart = cart; render(); return cart; });
  }

  function bundleInfo(cart) {
    var drawer = $('[data-pr-drawer]');
    if (!drawer || drawer.getAttribute('data-bundle') !== 'true') return null;
    var tiers = (drawer.getAttribute('data-tiers') || '2:10, 4:20, 6:30, 8:40').split(',').map(function (t) {
      var p = t.split(':'); return { q: parseInt(p[0], 10), p: parseFloat(p[1]) };
    }).filter(function (t) { return t.q > 0 && t.p > 0; }).sort(function (a, b) { return a.q - b.q; });
    if (!tiers.length) return null;
    var count = cart.item_count, percent = 0, next = null;
    tiers.forEach(function (t) { if (count >= t.q) percent = t.p; else if (!next) next = t; });
    var max = tiers[tiers.length - 1].q;
    return {
      tiers: tiers, max: max, count: count, percent: percent, next: next,
      left: next ? next.q - count : 0, unlocked: percent > 0,
      // Shopify already takes automatic discounts off total_price; only estimate if it hasn't yet
      dealTotal: cart.total_price < (cart.items_subtotal_price || cart.total_price)
        ? cart.total_price
        : Math.round((cart.items_subtotal_price || cart.total_price) * (1 - percent / 100))
    };
  }

  function render() {
    var cart = state.cart;
    if (!cart) return;
    var cur = cart.currency;

    $$('[data-pr-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
    $$('.pr-cart-pill').forEach(function (a) { a.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items'); });

    var drawer = $('[data-pr-drawer]');
    if (!drawer) { updateMobileBar(); return; }

    var itemsEl = $('[data-pr-items]', drawer);
    var empty = $('[data-pr-empty]', drawer);
    var foot = $('[data-pr-foot]', drawer);
    var bundleEl = $('[data-pr-bundle]', drawer);

    if (!cart.items.length) {
      itemsEl.innerHTML = '';
      empty.hidden = false;
      foot.hidden = true;
      if (bundleEl) bundleEl.hidden = true;
    } else {
      empty.hidden = true;
      foot.hidden = false;
      if (bundleEl) bundleEl.hidden = false;
      itemsEl.innerHTML = cart.items.map(function (item, i) {
        return '' +
          '<div class="pr-line">' +
            '<a href="' + esc(item.url) + '" class="pr-line__img">' + (item.image ? '<img src="' + esc(sized(item.image, 160)) + '" alt="" loading="lazy">' : '') + '</a>' +
            '<div class="pr-line__info">' +
              '<a href="' + esc(item.url) + '" class="pr-line__name">' + esc(cleanTitle(item.product_title)) + '</a>' +
              '<div class="pr-line__meta">' + (item.quantity > 1 ? item.quantity + ' \u00d7 ' : '') + 'PNG \u00b7 instant download' + '</div>' +
            '</div>' +
            '<div class="pr-line__price">' + money(item.final_line_price, cur) + '</div>' +
            '<button type="button" class="pr-icon-btn pr-line__remove" aria-label="Remove ' + esc(cleanTitle(item.product_title)) + '" data-pr-remove="' + (i + 1) + '">\u2715</button>' +
          '</div>';
      }).join('');
    }

    renderUps(drawer, cart);

    // Totals + bundle
    $('[data-pr-subtotal]', drawer).textContent = money(cart.items_subtotal_price || cart.total_price, cur);
    var b = bundleInfo(cart);
    var checkout = $('[data-pr-checkout]', drawer);
    var dealLine = $('[data-pr-deal-line]', drawer);
    var checkoutUrl = drawer.getAttribute('data-checkout') || (root + 'checkout');

    if (b) {
      var msg = $('[data-pr-bundle-msg]', drawer);
      var sub = $('[data-pr-bundle-sub]', drawer);
      if (b.unlocked && b.next) {
        msg.innerHTML = '<strong>' + b.percent + '% off</strong> unlocked \u2014 add ' + b.left + ' more for ' + b.next.p + '% off';
      } else if (b.unlocked) {
        msg.innerHTML = '<strong>' + b.percent + '% off</strong> unlocked \u2014 our biggest bundle discount';
      } else {
        msg.innerHTML = 'Add <strong>' + b.left + ' more design' + (b.left === 1 ? '' : 's') + '</strong> for ' + b.next.p + '% off';
      }
      sub.textContent = b.unlocked
        ? 'Applied automatically at checkout. No code needed.'
        : 'Buy more, save more: up to ' + b.tiers[b.tiers.length - 1].p + '% off. No code needed.';
      $$('[data-pr-bundle-steps] span', drawer).forEach(function (s, i) { s.classList.toggle('is-on', i < b.count); });
      $$('[data-pr-bundle-tiers] span', drawer).forEach(function (s) { s.classList.toggle('is-on', b.count >= parseInt(s.getAttribute('data-q'), 10)); });

      if (b.unlocked) {
        dealLine.hidden = false;
        $('[data-pr-deal-label]', drawer).textContent = 'With ' + b.percent + '% bundle discount';
        $('[data-pr-deal-total]', drawer).textContent = money(b.dealTotal, cur);
      } else {
        dealLine.hidden = true;
      }
    } else {
      dealLine.hidden = true;
    }
    checkout.href = checkoutUrl;
    updateMobileBar();
  }

  function updateMobileBar() {
    var bar = $('[data-pr-mbar]');
    var cart = state.cart;
    if (!bar || !cart) return;
    var drawer = $('[data-pr-drawer]');
    var b = bundleInfo(cart);
    var show = b && cart.item_count > 0 && drawer && drawer.hidden;
    bar.hidden = !show;
    if (!show) return;
    $('[data-pr-mbar-msg]', bar).textContent = b.unlocked
      ? b.percent + '% off unlocked' + (b.next ? ' \u00b7 add ' + b.left + ' for ' + b.next.p + '%' : '')
      : 'Add ' + b.left + ' more for ' + b.next.p + '% off';
    $('[data-pr-mbar-fill]', bar).style.width = Math.min(100, (b.count / b.max) * 100) + '%';
  }


  /* ---------- Cart upsells: related to the last item added, else the fallback collection ---------- */
  var recCache = {};
  function upCard(p) {
    return '' +
      '<div class="pr-ups__item">' +
        '<a href="' + esc(p.url) + '" class="pr-ups__img" tabindex="-1">' + (p.image ? '<img src="' + esc(sized(p.image, 300)) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<a href="' + esc(p.url) + '" class="pr-ups__name">' + esc(cleanTitle(p.title)) + '</a>' +
        '<span class="pr-ups__price">' + money(p.price, p.currency) + '</span>' +
        '<form method="post" action="' + root + 'cart/add" data-pr-add>' +
          '<input type="hidden" name="id" value="' + esc(p.variant) + '"><input type="hidden" name="quantity" value="1">' +
          '<button type="submit" class="pr-btn pr-btn--outline pr-ups__btn" data-added-label="✓ Added">+ Add</button>' +
        '</form>' +
      '</div>';
  }
  function renderUps(drawer, cart) {
    var wrap = $('[data-pr-ups]', drawer);
    if (!wrap) return;
    if (!cart.items.length) { wrap.hidden = true; return; }
    var limit = parseInt(wrap.getAttribute('data-limit'), 10) || 6;
    var inCartV = {}, inCartP = {};
    cart.items.forEach(function (it) { inCartV[String(it.variant_id)] = true; inCartP[String(it.product_id)] = true; });

    // Fallback list (server-rendered)
    var staticGrid = $('[data-pr-ups-static]', wrap);
    var shown = 0;
    $$('[data-pr-ups-item]', wrap).forEach(function (el) {
      var ok = !inCartV[el.getAttribute('data-variant')] && !inCartP[el.getAttribute('data-product')] && shown < limit;
      el.hidden = !ok;
      if (ok) shown++;
    });

    var recGrid = $('[data-pr-recs]', wrap);
    var useRecs = function (list) {
      var picks = (list || []).filter(function (p) { return !inCartP[String(p.id)] && !inCartV[String(p.variant)]; }).slice(0, limit);
      if (recGrid && picks.length >= 3) {
        recGrid.innerHTML = picks.map(upCard).join('');
        recGrid.hidden = false;
        if (staticGrid) staticGrid.hidden = true;
        wrap.hidden = false;
      } else {
        if (recGrid) recGrid.hidden = true;
        if (staticGrid) staticGrid.hidden = false;
        wrap.hidden = shown === 0;
      }
    };

    var anchor = cart.items[0]; // Shopify lists the most recently added item first
    var key = String(anchor.product_id);
    if (recCache[key]) { useRecs(recCache[key]); return; }
    useRecs(null);
    fetch(root + 'recommendations/products.json?product_id=' + encodeURIComponent(key) + '&limit=10&intent=related', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        var list = (data.products || []).map(function (p) {
          var v = (p.variants || []).filter(function (x) { return x.available; })[0];
          if (!v) return null;
          var img = p.featured_image || (p.images && p.images[0]) || '';
          if (img && img.indexOf('//') === 0) img = 'https:' + img;
          return { id: p.id, variant: v.id, title: p.title, url: p.url || (root + 'products/' + p.handle), image: img, price: v.price, currency: cart.currency };
        }).filter(Boolean);
        recCache[key] = list;
        if (state.cart && state.cart.items.length && String(state.cart.items[0].product_id) === key) useRecs(list);
      })
      .catch(function () { recCache[key] = []; });
  }

  /* ---------- Move the drawers to <body> so the dim overlay covers the whole page ---------- */
  function portalDrawers() {
    ['PrCartDrawer', 'PrMobileMenu'].forEach(function (id) {
      var all = $$('[id="' + id + '"]');
      if (!all.length) return;
      var fresh = all.filter(function (el) { return el.parentElement !== document.body; });
      var keep = fresh.length ? fresh[fresh.length - 1] : all[all.length - 1];
      all.forEach(function (el) { if (el !== keep) el.remove(); });
      if (keep.parentElement !== document.body) document.body.appendChild(keep);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', portalDrawers); else portalDrawers();
  document.addEventListener('shopify:section:load', function () { portalDrawers(); if (state.cart) render(); });

  /* ---------- Add / remove ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-pr-add]')) return;
    e.preventDefault();
    var btn = form.querySelector('button[type=submit]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }

    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        if (btn) {
          btn.innerHTML = btn.getAttribute('data-added-label') || '\u2713 Added';
          btn.removeAttribute('aria-busy');
          btn.disabled = false;
          setTimeout(function () { btn.innerHTML = label; }, 2200);
        }
        return fetchCart();
      })
      .then(function () {
        if (/\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
        var drawer = $('[data-pr-drawer]');
        if (drawer && drawer.hidden) openDrawer(drawer);
        document.dispatchEvent(new CustomEvent('princeium:cart-add'));
      })
      .catch(function () { form.submit(); });
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    var opener = t.closest('[data-pr-cart-open]');
    if (opener && $('[data-pr-drawer]')) {
      e.preventDefault();
      fetchCart().then(function () { openDrawer($('[data-pr-drawer]')); });
      return;
    }
    if (t.closest('[data-pr-cart-close]')) { closeDrawer($('[data-pr-drawer]')); return; }
    if (t.closest('[data-pr-menu-open]')) { openDrawer($('[data-pr-menu]')); return; }
    if (t.closest('[data-pr-menu-close]')) { closeDrawer($('[data-pr-menu]')); return; }

    var rm = t.closest('[data-pr-remove]');
    if (rm) {
      rm.disabled = true;
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(rm.getAttribute('data-pr-remove'), 10), quantity: 0 })
      }).then(function (r) { return r.json(); }).then(function (cart) { state.cart = cart; render(); });
      return;
    }

    // (product gallery clicks are handled in the gallery block below)
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDrawer($('[data-pr-drawer]'));
    closeDrawer($('[data-pr-menu]'));
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-pr-sort]')) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
  });

  // Close dropdown menus when clicking elsewhere
  document.addEventListener('click', function (e) {
    $$('.pr-nav__drop[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fetchCart);
  else fetchCart();
})();

/* ---------- Live search suggestions (Shopify predictive search) ---------- */
(function () {
  if (window.__princeiumSuggest) return;
  window.__princeiumSuggest = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  var cache = {};

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function cleanTitle(t) {
    t = String(t || '');
    var out = t.split(', ')[0].split(' | ')[0].split(' Sublimation')[0].split(' Png Design')[0].split(' PNG Design')[0].split(' Digital Download')[0].trim();
    var tail = out.slice(-4).toLowerCase();
    if (tail === ' png' || tail === ' svg') out = out.slice(0, -4).trim();
    return out || t;
  }
  function highlight(text, q) {
    var safe = esc(text);
    var i = text.toLowerCase().indexOf(q.toLowerCase());
    if (i < 0 || !q) return safe;
    return esc(text.slice(0, i)) + '<mark>' + esc(text.slice(i, i + q.length)) + '</mark>' + esc(text.slice(i + q.length));
  }
  function price(p) {
    var n = parseFloat(p);
    if (isNaN(n)) return '';
    if (n > 1000 && String(p).indexOf('.') === -1) n = n / 100;
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(n); } catch (e) { return '$' + n.toFixed(2); }
  }
  function searchUrl(q) { return root + 'search?q=' + encodeURIComponent(q) + '&type=product'; }

  function setup(form) {
    var input = form.querySelector('input[name=q]');
    var box = form.querySelector('[data-pr-suggest]');
    if (!input || !box) return;
    var timer = null, ctrl = null, active = -1;

    function options() { return Array.prototype.slice.call(box.querySelectorAll('[role=option]')); }
    function open() { box.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    function close() { box.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; input.removeAttribute('aria-activedescendant'); }
    function mark(i) {
      var opts = options();
      opts.forEach(function (o, k) { o.classList.toggle('is-active', k === i); o.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      active = i;
      if (opts[i]) { input.setAttribute('aria-activedescendant', opts[i].id); opts[i].scrollIntoView({ block: 'nearest' }); }
    }

    function renderPopular() {
      var urls = (form.getAttribute('data-popular-urls') || '').split('|');
      // Pair each term with its URL (its collection when one exists) before dropping blanks
      var list = (form.getAttribute('data-popular') || '').split(',').map(function (s, i) { return { t: s.trim(), u: (urls[i] || '').trim() }; }).filter(function (o) { return o.t; });
      if (!list.length) { close(); return; }
      box.innerHTML = '<div class="pr-suggest__label">Popular searches</div><div class="pr-suggest__chips">' +
        list.map(function (o, i) { return '<a role="option" id="' + box.id + '-p' + i + '" class="pr-chip" href="' + esc(o.u || searchUrl(o.t)) + '">' + esc(o.t) + '</a>'; }).join('') + '</div>';
      open();
    }

    function render(q, data) {
      var res = (data && data.resources && data.resources.results) || {};
      var queries = (res.queries || []).slice(0, 5);
      var products = (res.products || []).slice(0, 5);
      var SKIP = /^(all|frontpage|bestsellers|best-sellers|new-for-the-holidays.*)$/;
      var cols = (res.collections || []).filter(function (c) { return c && c.handle && !SKIP.test(c.handle); }).slice(0, 3);
      var html = '', n = 0;
      if (cols.length) {
        html += '<div class="pr-suggest__label">Collections</div><ul class="pr-suggest__list" role="listbox">';
        cols.forEach(function (c) {
          html += '<li><a role="option" id="' + box.id + '-o' + (n++) + '" class="pr-suggest__q pr-suggest__col" href="' + esc(c.url) + '">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>' +
            '<span>' + highlight(c.title, q) + '</span><span class="pr-suggest__tag">All designs</span></a></li>';
        });
        html += '</ul>';
      }
      if (queries.length) {
        html += '<div class="pr-suggest__label">Suggestions</div><ul class="pr-suggest__list" role="listbox">';
        queries.forEach(function (s) {
          html += '<li><a role="option" id="' + box.id + '-o' + (n++) + '" class="pr-suggest__q" href="' + esc(searchUrl(s.text)) + '">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>' +
            '<span>' + highlight(s.text, q) + '</span></a></li>';
        });
        html += '</ul>';
      }
      if (products.length) {
        html += '<div class="pr-suggest__label">Designs</div><ul class="pr-suggest__list" role="listbox">';
        products.forEach(function (p) {
          var img = p.image || (p.featured_image && p.featured_image.url) || '';
          if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
          html += '<li><a role="option" id="' + box.id + '-o' + (n++) + '" class="pr-suggest__p" href="' + esc(p.url) + '">' +
            '<span class="pr-suggest__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="pr-suggest__name">' + highlight(cleanTitle(p.title), q) + '</span>' +
            '<span class="pr-suggest__price">' + esc(price(p.price)) + '</span></a></li>';
        });
        html += '</ul>';
      }
      if (!queries.length && !products.length && !cols.length) {
        html += '<div class="pr-suggest__empty">No designs match \u201c' + esc(q) + '\u201d yet. Try a shorter word.</div>';
      }
      html += '<a role="option" id="' + box.id + '-all" class="pr-suggest__all" href="' + esc(searchUrl(q)) + '">See all results for \u201c' + esc(q) + '\u201d <span class="pr-arr" aria-hidden="true">\u2192</span></a>';
      box.innerHTML = html;
      active = -1;
      open();
    }

    function lookup() {
      var q = input.value.trim();
      if (q.length < 2) { renderPopular(); return; }
      if (cache[q]) { render(q, cache[q]); return; }
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) { cache[q] = data; if (input.value.trim() === q) render(q, data); })
        .catch(function () {});
    }

    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(lookup, 160); });
    input.addEventListener('focus', function () { if (!input.value.trim()) renderPopular(); else lookup(); });
    input.addEventListener('keydown', function (e) {
      var opts = options();
      if (e.key === 'ArrowDown') { e.preventDefault(); if (box.hidden) lookup(); mark(Math.min(active + 1, opts.length - 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); mark(Math.max(active - 1, 0)); }
      else if (e.key === 'Enter' && active > -1 && opts[active]) { e.preventDefault(); window.location.href = opts[active].href; }
      else if (e.key === 'Escape') { close(); }
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
  }

  function init() { Array.prototype.forEach.call(document.querySelectorAll('form[data-pr-predictive]'), setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* ---------- Review carousel: auto-rotate, swipe, arrows, progress ---------- */
(function () {
  if (window.__princeiumCarousel) return;
  window.__princeiumCarousel = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(track) {
    if (track.__prReady) return;
    track.__prReady = true;
    var root = track.closest('.pr-rv') || track.parentNode;
    var bar = root.querySelector('[data-pr-rv-bar]');
    var prev = root.querySelector('[data-pr-rv-prev]');
    var next = root.querySelector('[data-pr-rv-next]');
    var interval = parseInt(track.getAttribute('data-interval'), 10) || 3000;
    var auto = track.getAttribute('data-autoplay') === 'true' && !reduce;
    var paused = false, visible = true, timer = null, resumeT = null;

    function step() {
      var card = track.querySelector('.pr-rv__card');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    function atEnd() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 6; }
    function go(dir) {
      if (dir > 0 && atEnd()) track.scrollTo({ left: 0, behavior: reduce ? 'auto' : 'smooth' });
      else if (dir < 0 && track.scrollLeft <= 4) track.scrollTo({ left: track.scrollWidth, behavior: reduce ? 'auto' : 'smooth' });
      else track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' });
    }
    function progress() {
      if (!bar) return;
      var sw = track.scrollWidth, cw = track.clientWidth;
      if (sw <= cw) { bar.style.width = '100%'; bar.style.transform = 'none'; return; }
      bar.style.width = (cw / sw * 100) + '%';
      bar.style.transform = 'translateX(' + (track.scrollLeft / cw * 100) + '%)';
    }
    function tick() { if (!paused && visible && !document.hidden) go(1); }
    function start() { if (auto && !timer) timer = setInterval(tick, interval); }
    function pause() { paused = true; clearTimeout(resumeT); }
    function resumeSoon(ms) { clearTimeout(resumeT); resumeT = setTimeout(function () { paused = false; }, ms); }

    track.addEventListener('scroll', function () { window.requestAnimationFrame(progress); }, { passive: true });
    window.addEventListener('resize', progress);
    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', function () { resumeSoon(400); });
    track.addEventListener('focusin', pause);
    track.addEventListener('focusout', function () { resumeSoon(1500); });
    track.addEventListener('touchstart', pause, { passive: true });
    track.addEventListener('touchend', function () { resumeSoon(5000); }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });
    if (prev) prev.addEventListener('click', function () { pause(); go(-1); resumeSoon(6000); });
    if (next) next.addEventListener('click', function () { pause(); go(1); resumeSoon(6000); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }, { threshold: 0.25 }).observe(track);
    }
    progress();
    start();
  }

  function init() { Array.prototype.forEach.call(document.querySelectorAll('[data-pr-carousel]'), setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* ---------- Giant footer wordmark: scale to fill the width exactly ---------- */
(function () {
  function fit() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pr-fit]'), function (box) {
      var span = box.firstElementChild;
      if (!span) return;
      span.style.fontSize = '100px';
      var w = span.getBoundingClientRect().width;
      if (!w) return;
      var target = box.clientWidth * 0.96;
      span.style.fontSize = Math.floor(100 * target / w) + 'px';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fit); else fit();
  window.addEventListener('resize', fit);
  window.addEventListener('load', fit);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  document.addEventListener('shopify:section:load', fit);
})();

/* ---------- Footer: link columns are open on desktop, tap-to-open on phones ---------- */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  function sync() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pr-ft-acc]'), function (d) {
      if (mq.matches) { if (!d.__prTouched) d.removeAttribute('open'); }
      else d.setAttribute('open', '');
    });
  }
  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('.pr-ft__acc-title');
    if (s && s.parentNode) s.parentNode.__prTouched = true;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  if (mq.addEventListener) mq.addEventListener('change', sync); else if (mq.addListener) mq.addListener(sync);
  document.addEventListener('shopify:section:load', sync);
})();

/* Urgency line: refresh "last bought" and holiday countdown in the shopper's own time (pages can be cached) */
(function () {
  function run(root) {
    (root || document).querySelectorAll('[data-pr-proof]').forEach(function (box) {
      var now = Date.now();
      var win = parseInt(box.getAttribute('data-window'), 10) || 172800;
      var maxDays = parseInt(box.getAttribute('data-max-days'), 10) || 45;
      var last = box.querySelector('[data-pr-last]');
      if (last) {
        var ago = Math.max(0, Math.floor(now / 1000) - parseInt(last.getAttribute('data-pr-last'), 10));
        if (ago >= win) { last.hidden = true; }
        else {
          var h = Math.floor(ago / 3600);
          last.querySelector('[data-pr-last-text]').textContent = 'Last bought ' + (h < 1 ? 'under an hour ago' : h === 1 ? '1 hour ago' : h + ' hours ago');
        }
      }
      var hol = box.querySelector('[data-pr-holiday]');
      if (hol) {
        var p = (hol.getAttribute('data-pr-holiday') || '').split('-');
        if (p.length === 3) {
          var t = new Date(+p[0], +p[1] - 1, +p[2]);
          var today = new Date(); today.setHours(0, 0, 0, 0);
          var days = Math.round((t - today) / 86400000);
          var name = hol.getAttribute('data-name');
          if (days < 0 || days > maxDays) { hol.hidden = true; }
          else {
            hol.querySelector('[data-pr-holiday-text]').textContent = name + ' is ' + (days === 0 ? 'today' : days === 1 ? 'tomorrow' : 'in ' + days + ' days');
          }
        }
      }
      var visible = box.querySelectorAll('.pr-proof__item:not([hidden])').length;
      box.hidden = visible === 0;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); }); else run();
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();

/* Motion: smooth scrolling (Lenis, desktop) + fade-in on scroll. Toggled in the header section's "Motion" settings. */
(function () {
  if (window.__prMotion) return; window.__prMotion = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = window.Shopify && window.Shopify.designMode;
  function flags() {
    var h = document.querySelector('[data-pr-motion]');
    var v = h ? (h.getAttribute('data-pr-motion') || '') : '';
    return { smooth: v.indexOf('smooth') > -1, reveal: v.indexOf('reveal') > -1 };
  }

  function startSmooth() {
    if (reduce || editor || typeof window.Lenis !== 'function') return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var lenis = new window.Lenis({
      lerp: 0.09,
      wheelMultiplier: 1,
      autoRaf: true,
      anchors: { offset: -16, duration: 1.2 },
      prevent: function (node) {
        return !!(node && node.closest && node.closest('[data-pr-drawer], [data-pr-menu], [data-pr-suggest], .pr-rv__viewport, [data-pr-track], [data-pr-thumbs], select, textarea'));
      }
    });
    window.prLenis = lenis;
    var root = document.documentElement;
    var sync = function () { if (root.classList.contains('pr-lock')) lenis.stop(); else lenis.start(); };
    new MutationObserver(sync).observe(root, { attributes: true, attributeFilter: ['class'] });
  }

  var SEL = [
    '.pr .pr-h2', '.pr .pr-head-row', '.pr-card', '.pr-season', '.pr-tile', '.pr-step', '.pr-stats > *',
    '.pr-rv__head', '.pr-faq details', '.pr-faq__intro', '.pr-co__step', '.pr-co__idea', '.pr-co__review',
    '.pr-co__intro', '.pr-co__form', '.pr-co__final', '.pr-specs', '.pr-acc', '.pr-review-row'
  ].join(',');

  function startReveal() {
    if (reduce || editor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target; io.unobserve(el);
        el.classList.add('pr-in');
        var done = function () { el.classList.remove('pr-reveal', 'pr-in'); el.style.transitionDelay = ''; el.removeEventListener('transitionend', done); };
        el.addEventListener('transitionend', done);
        setTimeout(done, 1600);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    var vh = window.innerHeight;
    var counts = new Map();
    document.querySelectorAll(SEL).forEach(function (el) {
      if (el.closest('.pr-hero__grid, .pr-drawer, .pr-header, .pr-announce, .pr-ft') || el.classList.contains('pr-reveal')) return;
      if (el.getBoundingClientRect().top < vh * 0.92) return; // already on screen: leave it alone
      var p = el.parentElement, n = counts.get(p) || 0; counts.set(p, n + 1);
      el.style.transitionDelay = Math.min(n, 5) * 70 + 'ms';
      el.classList.add('pr-reveal');
      io.observe(el);
    });
  }

  function init() {
    var f = flags();
    if (f.smooth) startSmooth();
    if (f.reveal) startReveal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();


/* Product gallery: swipe on phones, arrows + thumbnails on desktop, thumbnails scroll sideways */
(function () {
  if (window.__prGallery) return; window.__prGallery = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(g) {
    if (g.__prReady) return; g.__prReady = true;
    var track = g.querySelector('[data-pr-track]');
    if (!track) return;
    var slides = track.children;
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-pr-thumb]'));
    var thumbRow = g.querySelector('[data-pr-thumbs]');
    var count = g.querySelector('[data-pr-gal-count]');
    var prev = g.querySelector('[data-pr-gal-prev]');
    var next = g.querySelector('[data-pr-gal-next]');
    var current = -1;

    function go(i, smooth) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth && !reduce ? 'smooth' : 'auto' });
      mark(i);
    }
    function mark(i) {
      if (i === current) return;
      current = i;
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      var th = thumbs[i];
      if (th && thumbRow) {
        var left = th.offsetLeft - (thumbRow.clientWidth - th.clientWidth) / 2;
        thumbRow.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
      }
    }

    var raf = 0;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); });
    }, { passive: true });

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-index'), 10) || 0, true); });
    });
    if (prev) prev.addEventListener('click', function () { go(current - 1, true); });
    if (next) next.addEventListener('click', function () { go(current + 1, true); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1, true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1, true); }
    });
    window.addEventListener('resize', function () { if (current > -1) track.scrollTo({ left: current * track.clientWidth }); });

    go(parseInt(track.getAttribute('data-start'), 10) || 0, false);
  }

  function init(root) { (root || document).querySelectorAll('[data-pr-gallery]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Countdown chips ("Christmas is in 76 days") refresh in the shopper's own time; "Show more designs" loads the next batch in place */
(function () {
  if (window.__prCollection) return; window.__prCollection = true;

  function countdowns(root) {
    (root || document).querySelectorAll('[data-pr-days-until]').forEach(function (el) {
      var p = (el.getAttribute('data-pr-days-until') || '').split('-');
      if (p.length !== 3) return;
      var t = new Date(+p[0], +p[1] - 1, +p[2]);
      var today = new Date(); today.setHours(0, 0, 0, 0);
      var d = Math.round((t - today) / 86400000);
      if (d < 0) { el.hidden = true; el.style.display = 'none'; return; }
      var rel = d === 0 ? 'today' : d === 1 ? 'tomorrow' : 'in ' + d + ' days';
      if (el.getAttribute('data-format') === 'short') el.textContent = rel.charAt(0).toUpperCase() + rel.slice(1);
      else el.textContent = (el.getAttribute('data-name') || '') + ' is ' + rel;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { countdowns(); }); else countdowns();
  document.addEventListener('shopify:section:load', function (e) { countdowns(e.target); });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pr-loadmore]');
    if (!btn) return;
    var grid = document.querySelector('[data-pr-grid]');
    var wrap = btn.closest('[data-pr-loadmore-wrap]');
    if (!grid || !wrap || !window.fetch || !window.DOMParser) return; // falls back to a normal page link
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    fetch(btn.href, { headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error('load'); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.querySelector('[data-pr-grid]');
        var nextWrap = doc.querySelector('[data-pr-loadmore-wrap]');
        if (!nextGrid) throw new Error('no grid');
        Array.prototype.slice.call(nextGrid.children).forEach(function (card) { grid.appendChild(document.importNode(card, true)); });
        if (nextWrap) {
          var txt = nextWrap.querySelector('[data-pr-shown]'), bar = nextWrap.querySelector('[data-pr-progress]');
          if (txt) wrap.querySelector('[data-pr-shown]').textContent = txt.textContent;
          if (bar) wrap.querySelector('[data-pr-progress]').style.width = bar.style.width;
          var nb = nextWrap.querySelector('[data-pr-loadmore]');
          if (nb) { btn.href = nb.href; btn.removeAttribute('aria-busy'); } else { btn.remove(); }
        } else { btn.remove(); }
      })
      .catch(function () { window.location.href = btn.href; });
  });
})();

/* ---------- Desktop nav: open dropdowns on hover ---------- */
(function () {
  if (window.__princeiumHoverNav) return;
  window.__princeiumHoverNav = true;
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  function init() {
    document.querySelectorAll('.pr-nav__drop').forEach(function (d) {
      var timer;
      function open() {
        if (!canHover.matches) return;
        clearTimeout(timer);
        document.querySelectorAll('.pr-nav__drop[open]').forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
        d.setAttribute('open', '');
      }
      function close() {
        if (!canHover.matches) return;
        clearTimeout(timer);
        timer = setTimeout(function () { d.removeAttribute('open'); }, 220);
      }
      d.addEventListener('mouseenter', open);
      d.addEventListener('mouseleave', close);
      // A mouse click on the label while hovering keeps it open instead of toggling it shut
      var sum = d.querySelector('summary');
      if (sum) sum.addEventListener('click', function (e) {
        if (canHover.matches && e.detail > 0 && d.hasAttribute('open')) e.preventDefault();
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') document.querySelectorAll('.pr-nav__drop[open]').forEach(function (o) { o.removeAttribute('open'); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();


/* ---------- Cursor dot: a small orange dot that trails the mouse (desktop only) ---------- */
(function () {
  if (window.__princeiumBuddy) return;
  window.__princeiumBuddy = true;
  function init() {
    var el = document.querySelector('[data-pr-buddy]');
    if (!el) return;
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    var still = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!fine.matches || still.matches) return;
    document.body.appendChild(el);
    var tx = -100, ty = -100, x = -100, y = -100, raf = null, shown = false, lastX = 0, tilt = 0;
    function tick() {
      x += (tx - x) * 0.22;
      y += (ty - y) * 0.22;
      var vx = tx - lastX; lastX = tx;
      tilt += (Math.max(-18, Math.min(18, vx * 0.9)) - tilt) * 0.15;
      el.style.transform = 'translate3d(' + (x - 6) + 'px,' + (y - 6) + 'px,0)';
      if (Math.abs(tx - x) > 0.3 || Math.abs(ty - y) > 0.3 || Math.abs(tilt) > 0.2) raf = requestAnimationFrame(tick); else raf = null;
    }
    document.addEventListener('mousemove', function (e) {
      tx = e.clientX; ty = e.clientY;
      if (!shown) { shown = true; x = tx; y = ty; el.hidden = false; }
      if (!raf) raf = requestAnimationFrame(tick);
    }, { passive: true });
    document.addEventListener('mouseleave', function () { el.classList.add('is-away'); });
    document.addEventListener('mouseenter', function () { el.classList.remove('is-away'); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();